import React from "react"

const App = () => {
  return (
    <svg
      fill="none"
      height="22"
      viewBox="0 0 14 14"
      width="22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2_779)">
        <path
          clipRule="evenodd"
          d="M12.265 6.987C12.2588 8.12124 11.861 9.21852 11.1388 10.0932C10.4167 10.9679 9.41456 11.5662 8.302 11.787C8.18303 11.8052 8.06149 11.7966 7.94626 11.7619C7.83103 11.7271 7.72503 11.667 7.63599 11.586C7.54695 11.5051 7.47714 11.4052 7.43163 11.2938C7.38613 11.1823 7.3661 11.0622 7.373 10.942L7.393 3.053C7.38673 2.93214 7.40733 2.81139 7.45331 2.69943C7.49929 2.58748 7.56951 2.48711 7.65892 2.40554C7.74833 2.32397 7.85471 2.26324 7.9704 2.2277C8.08609 2.19216 8.20822 2.1827 8.328 2.2C9.43809 2.41493 10.4385 3.01011 11.1571 3.88311C11.8757 4.75611 12.2675 5.8523 12.265 6.983V6.987ZM11.937 11.933C12.9073 10.9526 13.5655 9.70684 13.8285 8.3528C14.0915 6.99877 13.9475 5.59717 13.4148 4.32486C12.882 3.05255 11.9844 1.96655 10.8351 1.20388C9.68574 0.44122 8.33627 0.036067 6.95693 0.0395502C5.5776 0.0430333 4.2302 0.454996 3.08475 1.22346C1.9393 1.99192 1.04713 3.08244 0.520817 4.35742C-0.00549495 5.6324 -0.142368 7.03471 0.12747 8.3874C0.397308 9.74009 1.06177 10.9826 2.037 11.958C2.6884 12.6067 3.4612 13.1208 4.31127 13.4708C5.16134 13.8208 6.07204 14 6.99135 13.998C7.91066 13.9961 8.82059 13.813 9.66917 13.4594C10.5177 13.1058 11.2884 12.5885 11.937 11.937V11.933Z"
          fill="var(--color-title)"
          fillRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_779">
          <rect fill="white" height="14" width="14" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default App
